<template>
  <div class="image_container">
    <NavBar title="云影像" @onClickLeft="onClickLeft"> </NavBar>
    <div class="img_dicom">
      <div class="img_dicom_nav" :style="navPosition">
        <div ref="wrapper" class="wrapper_left">
          <ul class="img_dicom_nav_left" ref="cont">
            <li
              v-for="(item, key) in featuresList"
              :key="key"
              :class="{ active: active == key }"
              @click="turnPage(item.methodName), item.isSelected ? (active = key) : 1"
            >
              <div class="img_dicom_nav_img">
                <img :src="item.url" />
              </div>
              <p>{{ item.text }}</p>
            </li>
          </ul>
        </div>
        <van-popover
          v-model="isNavPosition"
          :placement="placement"
          theme="dark"
          trigger="click"
          :actions="actions"
          @select="setNavPosition"
        >
        </van-popover>
        <div class="img_dicom_nav_right">
          <div class="img_dicom_nav_reset">
            <div class="img_dicom_nav_img" @click="Reset">
              <img src="../../../assets/重置.png" />
            </div>
            <p>重置</p>
          </div>
          <div class="img_dicom_nav_reset">
            <div class="img_dicom_nav_img" @click="openSequence">
              <img src="../../../assets/无序列表.png" />
            </div>
            <p>序列</p>
          </div>
        </div>
      </div>
      <div
        class="viewportWrapper"
        oncontextmenu="return false"
        unselectable="on"
        onselectstart="return false"
        onmousedown="return false;"
      >
        <!-- :style="{ height: dicomHeight - 101 + 'px' }" -->
        <div class="viewport" ref="img_canvas" data-index="0" oncontextmenu="return false"></div>
        <div class="overlay_top">
          <div class="overlay">
            <div>姓名:{{ IsEncryption ? '***' : patientInfo.name }}</div>
            <div>性别:{{ patientInfo.sex }}</div>
            <div>年龄:{{ patientInfo.age }}</div>
            <div>{{ patientInfo.accessionNumber }}</div>
            <div>{{ patientInfo.patientId }}</div>
          </div>
          <div>
            <div>医院名称:{{ patientInfo.hosptialName | ellipsis }}</div>
            <div>检查日期:{{ patientInfo.checkDate }}</div>
            <div>检查时间:{{ patientInfo.checkTime }}</div>
          </div>
        </div>
        <div class="overlay_bottom">
          <div class="overlay_b">
            <div class="overlay">
              <div>图像序号:{{ chestStack.currentImageIdIndex + 1 }}</div>
            </div>

            <div>
              <div>Zoom:{{ zoom }}</div>
              <div>WW/WC:{{ wwc }}</div>
            </div>
          </div>
          <!-- :slideIndex="slideIndex" -->
          <!-- @preImage="preImage" -->
          <!-- @nextImage="nextImage" -->
          <!-- @onSliderChange="onSliderChange" -->
          <!-- @onLookPlay="onLookPlay" -->
          <LoopPlay
            ref="loopPlay"
            :imageCount="imageCount"
            :currentDicomIndex.sync="chestStack.currentImageIdIndex"
            @loadCurrnetDicom="loadCurrnetDicom"
          ></LoopPlay>
        </div>
      </div>
      <van-popup
        v-model="isSequenceShow"
        position="right"
        :style="{ width: '70%' }"
        :lazy-render="false"
        style="height: calc(100%); background-color: rgb(45, 50, 69)"
      >
        <van-cell title="检查序列">
          <template #extra>
            <div style="line-height: 18px">
              <p>{{ serialFirstList.length }}&nbsp;序列</p>
              <p>{{ count }}&nbsp;影像</p>
            </div>
            <div @click="isSequenceShow = false">
              <van-icon name="arrow" class="arrow" />
            </div>
          </template>
        </van-cell>
        <ul class="img_list">
          <li
            @click="selectSerial(key), (serialActive = key)"
            v-for="(item, key) in serialFirstList"
            :key="key"
            :class="{ serialActive: serialActive == key }"
          >
            <div class="menu_imge">
              <div
                ref="dicom"
                v-bind:style="{ width: '64px', height: '64px' }"
                data-index="0"
                oncontextmenu="return false"
              ></div>
            </div>
            <div class="menu_text">
              <!-- <p>检查号：{{ item.accessionNumber }}</p> -->
              <!-- <p>姓名：{{ item.name }}</p> -->
              <p>{{ item.seriesDescription }}</p>
              <p>共&nbsp;{{ item.imageCount }}&nbsp;张</p>
              <p v-html="moment(item.checkDate).format('YYYYMMDD') + replaceTime(item.checkTime)"></p>
            </div>
          </li>
        </ul>
      </van-popup>
    </div>
    <!-- <van-popup class="van_popup" v-model="isNavPosition" :close-on-click-overlay="false">
      <h3>设置</h3>
      <van-radio-group v-model="navPositionRadio" direction="horizontal">
        工具栏位置：
        <van-radio name="1">上</van-radio>
        <van-radio name="2">下</van-radio>
      </van-radio-group>
      <div class="set_location_b">
        <van-button type="default" @click="setNavPosition">确认</van-button>
        <van-button type="default" @click="isNavPosition = false">取消</van-button>
      </div>
    </van-popup> -->
    <van-dialog
      v-model="arrowAnnotate"
      title="输入注释："
      @confirm="setAnnotate(arrowAnnotateValue)"
      @close="arrowAnnotateValue = ''"
    >
      <van-field v-model="arrowAnnotateValue" placeholder="请输入注释" />
    </van-dialog>
    <van-loading type="spinner" class="loading" v-show="loadingSohw" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar/index.vue'
import LoopPlay from '@/components/LoopPlay/index'
import { DecryptAES } from '@/utils/stringUtils'
import { isMobile } from '@/utils/common'
import BScroll from '@better-scroll/core'
import * as cornerstone from '../../../../public/static/cornerstone.js'
import * as cornerstoneWADOImageLoader from '../../../../public/static/cornerstoneWADOImageLoader.js'
import * as Hammer from '../../../../public/static/hammer.js'
import * as cornerstoneMath from '../../../../public/static/cornerstoneMath.js'
import * as cornerstoneTools from '../../../../public/static/cornerstoneTools.js'
import * as dicomParser from '../../../../public/static/dicomParser.min.js'
import { converter } from '@/utils/encodeConverter'
import { GetFileServiceUrl, GetGoBackUrlParms } from '@/utils/cacheUtils'
import { GetPatientReportImageInfos, AddCloudImageViewRecord } from '@/api/CloudFilmService'
import { ArrayGroup } from '@/utils/common'

cornerstoneTools.external.Hammer = Hammer
cornerstoneTools.external.cornerstone = cornerstone
cornerstoneTools.external.cornerstoneMath = cornerstoneMath
cornerstoneTools.init({
  /**
   * When cornerstone elements are enabled,
   * should `mouse` input events be listened for?
   */
  mouseEnabled: true,
  /**
   * When cornerstone elements are enabled,
   * should `touch` input events be listened for?
   */
  touchEnabled: true,
  /**
   * A special flag that synchronizes newly enabled cornerstone elements. When
   * enabled, their active tools are set to reflect tools that have been
   * activated with `setToolActive`.
   */
  globalToolSyncEnabled: false,
  /**
   * Most tools have an associated canvas or SVG cursor. Enabling this flag
   * causes the cursor to be shown when the tool is active, bound to left
   * click, and the user is hovering the enabledElement.
   */
  showSVGCursors: false,
})

cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath
//指定要注册加载程序的基石实例
cornerstoneWADOImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.dicomParser = dicomParser
cornerstone.registerImageLoader('http', cornerstoneWADOImageLoader.loadImage)
cornerstone.registerImageLoader('https', cornerstoneWADOImageLoader.loadImage)

export default {
  name: 'ImageView',
  components: {
    NavBar,
    LoopPlay,
  },
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0, 10) + '...'
      }
      return value
    },
  },
  data() {
    return {
      active: 2,
      imageList: [],
      serialFirstList: [],
      featuresList: [
        { url: require('../../../assets/调窗.png'), text: '调窗', methodName: 'Wwwc', isSelected: true },
        // { url: require('../../../assets/缩放.png'), text: '缩放', methodName: 'ZoomTouchPinch' },
        { url: require('../../../assets/移动.png'), text: '平移', methodName: 'Pan', isSelected: true },
        { url: require('@/assets/翻页.png'), text: '翻页', methodName: 'StackScroll', isSelected: true },
        { url: require('../../../assets/放大镜.png'), text: '放大镜', methodName: 'Magnify', isSelected: true },
        { url: require('../../../assets/旋转.png'), text: '旋转', methodName: 'Rotation', isSelected: false },
        { url: require('@/assets/四角信息.png'), text: '信息', methodName: 'fourcornerinformation', isSelected: false },
        // { url: require('../../../assets/测量.png'), text: '标注', methodName: '' },
        { url: require('@/assets/点测量.png'), text: '点测量', methodName: 'Probe', isSelected: true },
        { url: require('../../../assets/角度测量.png'), text: '角度', methodName: 'Angle', isSelected: true },
        { url: require('../../../assets/直线测量.png'), text: '直线', methodName: 'Length', isSelected: true },
        { url: require('../../../assets/矩形测量.png'), text: '矩形', methodName: 'Rectangle', isSelected: true },
        // { url: require('../../../assets/清除标记.png'), text: '清除', methodName: 'Test', isSelected: true },
        {
          url: require('../../../assets/图像增强.png'),
          text: '图像增强',
          methodName: 'Interpolation',
          isSelected: false,
        },
        { url: require('../../../assets/反色.png'), text: '反色', methodName: 'Invert', isSelected: false },
        { url: require('../../../assets/任意角度旋转.png'), text: '自由转动', methodName: 'Rotate',isSelected: true },
        {
          url: require('../../../assets/水平旋转.png'),
          text: '水平旋转',
          methodName: 'HorizontalRotation',
          isSelected: false,
        },
        { url: require('../../../assets/标识.png'), text: '标识', methodName: 'ArrowAnnotate', isSelected: true },
        { url: require('../../../assets/骨窗.png'), text: '骨窗', methodName: 'Bone', isSelected: true },
        { url: require('../../../assets/脑窗.png'), text: '脑窗', methodName: 'Brain', isSelected: true },
        { url: require('../../../assets/肺窗.png'), text: '肺窗', methodName: 'Lung', isSelected: true },
        { url: require('../../../assets/软组织窗.png'), text: '软组织窗', methodName: 'SoftTissue', isSelected: true },
        { url: require('../../../assets/设置.png'), text: '菜单位置', methodName: 'openNavSet', isSelected: false },
        // { url: require('../../../assets/android-sunny.png'), text: '电擦除', methodName: 'BrushTool', isSelected: true },
      ],
      isSequenceShow: false,
      serialActive: 0,
      imageCount: 0,
      patientInfo: {
        name: '',
        patientId: '',
        accessionNumber: '',
        number: '',
        sex: '',
        age: '',
        checkDate: '',
        checkTime: '',
        hosptialName: '',
        zoom: '',
        wwc: '',
        seriesDescription: '',
      },
      IsEncryption: false,
      currentDicomIndex: 0,
      navPosition: '',
      isFourcornerinformationShow: true,
      loadingSohw: false,
      count: 0,
      dicomHeight: 0,
      chestStack: {
        currentImageIdIndex: 0,
        imageIds: [],
      },
      isNavPosition: false,
      navPositionRadio: '1',
      serialList: [],
      wwc: '',
      zoom: '',
      scroll: null,
      actions: [
        { text: '上', id: '1' },
        { text: '下', id: '2' },
      ],
      placement: 'bottom-end',
      arrowAnnotate: false,
      arrowAnnotateValue: '',
      currentserial: '',
      cleanupToolImgID: '',
      lastToolName:''
    }
  },
  watch: {
    // 监听图像序号变化，赋值给循环控件滑块
    'chestStack.currentImageIdIndex'(newValue) {
      this.$refs.loopPlay.slideIndex = newValue + 1
    },
  },
  created() {
    document.body.style.overflow = 'hidden'
    // this.dicomHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  },
  activated() {
    this.loadingSohw = true
    this.IsEncryption = DecryptAES(this.$route.query.isEncryption) === '1'
    this.getDicomData() //
    this.$nextTick(() => {
      this.verScroll()
    this.setNavPositionCallback(localStorage.getItem('navPosition'))
    })
  },
  deactivated() {
    document.body.style.overflow = ''
  },
  methods: {
    replaceTime(checkTime) {
      if (checkTime) {
        return checkTime.replace(/:/g, '')
      } else {
        return ''
      }
    },
    onClickLeft() {
      this.$refs.loopPlay.onLookPlay(1)
      if (this.scroll) this.scroll.scrollToElement(this.$refs.wrapper)
      Object.assign(this.$data, this.$options.data()) // 初始化data数据
      this.$router.push({ path: '/reportView?' + GetGoBackUrlParms() })
    },
    //获取服务器数据
    getDicomData() {
      this.loadingSohw = true
      GetPatientReportImageInfos({ patientreportID: this.$route.query.reportInfoID })
        .then(async (resp) => {
          if (resp && resp.Success && resp.Result) {
            let FilmFileList = resp.Result.find((c) => c.Category === 2)
            if (FilmFileList && FilmFileList.Images && FilmFileList.Images.length > 0) {
              AddCloudImageViewRecord({
                CloudImagePatientID: DecryptAES(this.$route.query.CloudImagePatientID),
                IDs: FilmFileList.ExaminationImageIDs,
              }).then()
            }

            let fimeImages = resp.Result.filter((c) => c.Category === 2).map((c) => c.Images)
            if (fimeImages && fimeImages.length > 0) {
              fimeImages = fimeImages[0]
              const fileServiceUrl = await GetFileServiceUrl()
              let NewSerialIndex = 0
              let OldSerialIndex = fimeImages[0].SerialIndex
              fimeImages.forEach((c) => {
                c.ImageRelaFileName = fileServiceUrl + c.ImageRelaFileName
                if (OldSerialIndex !== c.SerialIndex) {
                  OldSerialIndex = c.SerialIndex
                  NewSerialIndex = NewSerialIndex + 1
                }
                c.SerialIndex = NewSerialIndex
              })
              var imageGroup = ArrayGroup(fimeImages, 'SerialIndex')
              if (imageGroup) {
                this.serialList = []
                imageGroup.forEach((item) => {
                  this.serialList[item.key] = item.value
                })
                //滑动翻页
                this.ScrollMouseWheel(this.serialList[0])
                //获取序列第一张图
                this.serialFirstList = []
                this.serialList.forEach((item, serialIndex) => {
                  this.getDicomInfo(item, serialIndex)
                  this.serialFirstList.push({
                    key: serialIndex,
                    dicom: item[0],
                    imageCount: item.length,
                  })
                })
                this.$nextTick(() => {
                  this.getSerialList()
                })
              }
            } else {
              this.loadingSohw = false
              this.$notify({ type: 'warning', message: '没有查询到该检查的原始影像！' })
            }
          } else {
            this.loadingSohw = false
          }
        })
        .catch((err) => {
          this.loadingSohw = false
        })
    },
    // 初始化数据
    setImage() {
      //获取序列第一张图
      this.ScrollMouseWheel(this.imageList[this.$route.query.sequenceKey])
      this.serialActive = this.$route.query.sequenceKey
      this.serialFirstList = []
      this.imageList.forEach((item, serialIndex) => {
        this.getDicomInfo(item, serialIndex)
        this.serialFirstList.push({
          key: serialIndex,
          dicom: item[0],
          imageCount: item.length,
        })
      })
    },
    //功能按钮事件
    turnPage(methodName) {
      // console.log(methodName);
      this.$refs.loopPlay.onLookPlay(1)
      this[methodName]()
    },
    // 功能导航栏的位置
    openNavSet() {
      this.isNavPosition = true
    },
    // 设置导航位置
    setNavPosition(actions) {
      localStorage.setItem('navPosition', actions.id)
      this.setNavPositionCallback(actions.id)
      // localStorage.setItem('navPosition', this.navPositionRadio)
      // this.setNavPositionCallback(this.navPositionRadio)
      // this.isNavPosition = false
    },
    // 设置导航位置回调
    setNavPositionCallback(value) {
      if (value === '2') {
        this.navPosition = {
          position: 'absolute',
          bottom: 0,
        }
        this.placement = 'top-end'
      } else {
        this.navPosition = ''
        this.placement = 'bottom-end'
      }
      this.navPositionRadio = value || '1'
    },
    //设置滚动
    verScroll() {
      // let width = document.body.clientWidth // 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      this.$refs.cont.style.width = 50 * this.featuresList.length + 28 + 'px' // 修改滚动区域的宽度
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          startX: 0, // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical',
        })
      } else {
        this.scroll.refresh() //如果dom结构发生改变调用该方法
      }
    },
    // 获取dicom信息
    getDicomInfo(item, index) {
      var that = this
      var dicom = item[0]
      // let imageId = "wadouri:" + vue.prototype.appConfig.DicomUrl + dicom.ImagePath;
      let imageId = 'wadouri:' + dicom.ImageRelaFileName
      // load images and set the stack
      cornerstone.loadAndCacheImage(imageId).then((image) => {
        this.patientInfo = that.serialFirstList[index]
        //检查号
        this.patientInfo.accessionNumber = image.data.string('x00080050')
        //影像号
        this.patientInfo.patientId = image.data.string('x00100020')
        //姓名
        var code = image.data.string('x00080005')
        if (code == 'GB18030') {
          code = 'ISO_IR 100'
        }
        if (code !== undefined) {
          //姓名
          this.patientInfo.name = converter(image.data.string('x00100010'), code, 'gb18030')
          //医院名称
          this.patientInfo.hosptialName = converter(image.data.string('x00080080'), code, 'gb18030')
        } else {
          code = 'ISO_IR 100'
          var encode = 'gb18030' //gbk gb18030;
          //姓名
          this.patientInfo.name = converter(image.data.string('x00100010'), code, encode)
          //医院名称
          this.patientInfo.hosptialName = converter(image.data.string('x00080080'), code, encode)
        }
        //年龄
        this.patientInfo.age = image.data.string('x00101010')
        //性别
        this.patientInfo.sex = image.data.string('x00100040')
        // 系列说明
        this.patientInfo.seriesDescription = image.data.string('x0008103e')
        //检查日期
        this.patientInfo.checkDate = this.moment(image.data.string('x00080022')).format('YYYY-MM-DD')
        //检查时间
        const time = image.data.string('x00080030')
        if (time.length >= 6) {
          this.patientInfo.checkTime = time.substring(0, 2) + ':' + time.substring(2, 4) + ':' + time.substring(4, 6)
        }

        //图像序列
        this.patientInfo.number = image.data.string('x00200013')
        //放缩比
        this.patientInfo.zoom = image.data.string('x00100020')

        //第一次加载获取最开始放缩比记录当前值
        this.currentZoom = parseFloat(this.patientInfo.zoom).toFixed(2)
        //窗宽窗位
        this.wwc = image.data.string('x00281051')
        this.zoom = image.data.string('x00100020')
      })
    },
    //获取序列显示图像信息
    getSerialList() {
      var index = 0
      //生成图像
      var count = []
      this.serialFirstList.forEach((item) => {
        count.push(item.imageCount)
        //生成图像
        // 找到要渲染的元素
        const canvas = this.$refs.dicom[index]
        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)
        var dicom = item.dicom
        let imageId = 'wadouri:' + dicom.ImageRelaFileName
        cornerstone.loadAndCacheImage(imageId).then(
          function (image) {
            // 设置元素视口
            var viewport = cornerstone.getDefaultViewportForImage(canvas, image)
            // 显示图像
            cornerstone.displayImage(canvas, image, viewport)
          },
          function (err) {
            alert(err)
          }
        )

        index++
      })
      this.count = eval(count.join('+')) //计算影像总数
    },
    //加载图像
    ScrollMouseWheel(series) {
      this.loadingSohw = true
      var canvasList = []
      let canvass = this.$refs.img_canvas
      canvasList.push(canvass)
      const chestImageIds = new Array()
      series.forEach((item) => {
        chestImageIds.push(`wadouri:${item.ImageRelaFileName}`)
      })
      this.chestStack.imageIds = chestImageIds
      canvasList.forEach((canvas) => {
        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)
        const scheme = 'wadouri'
        var list = []
        list = series
        const imageIds = list.map((seriesImage) => `${scheme}:${seriesImage.ImageRelaFileName}`)
        //获取当前序列
        this.currentserial = imageIds
        this.imageCount = imageIds.length
        //设置显示数量
        this.slideCount = '1/' + this.imageCount
        cornerstone.loadImage(imageIds[0]).then((image) => {
          cornerstone.displayImage(canvas, image)
          cornerstoneTools.addStackStateManager(canvas, ['stack', 'StackScroll'])
          cornerstoneTools.addToolState(canvas, 'stack', this.chestStack)
          //重置
          cornerstone.reset(canvas)
          this.StackScroll() //上下翻页
          this.ZoomTouchPinch() // 缩放
          // this.Rotate()  // 自由旋转
          // this.OrientationMarkers() // 方位
          // this.ScaleOverlayTool() // 标尺
        })
        //滑动时，执行事件
        canvas.addEventListener('cornerstoneimagerendered', this.onImageRendered)
        setTimeout(() => {
          this.loadingSohw = false
        }, 500)
      })
    },
    // 选择序列
    selectSerial(key) {
      this.$refs.loopPlay.slideIndex = 1
      this.chestStack.currentImageIdIndex = 0
      this.showSerialPannel = false
      //加载序列列表
      this.ScrollMouseWheel(this.serialList[key])
      this.isSequenceShow = false
    },

    //加载当前影像
    loadCurrnetDicom(index) {
      let canvas = this.$refs.img_canvas
      // 在 DOM 中将 canvas 元素注册到 cornerstone
      cornerstone.enable(canvas)
      //当前序列名称
      const imageIds = this.currentserial
      //获取当前序列
      this.currentserial = imageIds
      let currentImageId = this.currentserial[index]
      canvas.tabIndex = 0
      canvas.focus()
      cornerstone.loadAndCacheImage(currentImageId).then((image) => {
        cornerstone.displayImage(canvas, image)
      })
    },
    //滑动或者翻页时，执行事件
    onImageRendered(e) {
      this.cleanupToolImgID = e.detail.image.imageId
      const eventData = e.detail
      //图像序列
      this.patientInfo.number = eventData.image.data.string('x00200013')
      //放缩比
      this.patientInfo.zoom = eventData.viewport.scale.toFixed(2)
      this.zoom = eventData.viewport.scale.toFixed(2)
      //获取当前缩放比
      //窗宽窗位
      this.wwc = parseInt(eventData.viewport.voi.windowWidth) + '/' + parseInt(eventData.viewport.voi.windowCenter)
    },
    //重置
    Reset() {
      this.removeOption('Reset')
      this.$refs.loopPlay.onLookPlay(1)
      let canvas = this.$refs.img_canvas
      cornerstone.reset(canvas)
      this.active = 2
      this.StackScroll()
      if (this.scroll) this.scroll.scrollToElement(this.$refs.wrapper)
      this.init()
    },
    // 打开序列
    openSequence() {
      this.$refs.loopPlay.onLookPlay(1)
      this.isSequenceShow = true
      this.$nextTick(() => {
        this.getSerialList()
      })
    },
    //四有信息
    fourcornerinformation() {
      if (this.isFourcornerinformationShow) {
        document.getElementsByClassName('overlay_top')[0].style.display = 'none'
        document.getElementsByClassName('overlay_b')[0].style.display = 'none'
      } else {
        document.getElementsByClassName('overlay_top')[0].style.display = ''
        document.getElementsByClassName('overlay_b')[0].style.display = ''
      }
      this.isFourcornerinformationShow = !this.isFourcornerinformationShow
    },
    // 标尺
    ScaleOverlayTool() {
      let ScaleOverlayTool = cornerstoneTools.ScaleOverlayTool
      cornerstoneTools.addTool(ScaleOverlayTool, {
        configuration: {
          minorTickLength: 12.5, //小节拍长度
          majorTickLength: 25, //大节拍长度,并不是总长度,总长度会根据canvas大小调整
        },
      })
      cornerstoneTools.setToolActive('ScaleOverlay', {
        mouseButtonMask: 1,
      })
    },

    //平移
    Pan() {
      this.removeOption('Pan')
      const PanTool = cornerstoneTools.PanTool
      cornerstoneTools.addTool(PanTool)
      cornerstoneTools.setToolActive('Pan', {
        mouseButtonMask: 1,
      })
    },
    //放大镜
    Magnify() {
      this.removeOption('Magnify')
      const MagnifyTool = cornerstoneTools.MagnifyTool
      cornerstoneTools.addTool(MagnifyTool)
      cornerstoneTools.setToolActive('Magnify', {
        mouseButtonMask: 1,
      })
    },
    //旋转
    Rotation() {
      this.removeOption('Rotation')
      let canvas = this.$refs.img_canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.rotation -= 90
      cornerstone.setViewport(canvas, viewport)
    },
    //触放缩
    ZoomTouchPinch() {
      this.removeOption('ZoomTouchPinch')
      if (isMobile()) {
        cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool, {
          // Optional configuration
          configuration: {
            invert: false,
            preventZoomOutsideImage: false,
            minScale: 0.01,
            maxScale: 20.0,
          },
        })
        cornerstoneTools.setToolActive('ZoomTouchPinch', {
          mouseButtonMask: 1,
        })
      } else {
        this.Zoom()
      }
    },
    //缩放
    Zoom() {
      this.removeOption('Zoom')
      cornerstoneTools.addTool(cornerstoneTools.ZoomTool, {
        // Optional configuration
        configuration: {
          invert: false,
          preventZoomOutsideImage: false,
          minScale: this.currentZoom / 10,
          maxScale: 20.0,
        },
      })

      cornerstoneTools.setToolActive('Zoom', {
        mouseButtonMask: 1,
      })
    },
    // 窗宽窗位
    Wwwc() {
      this.removeOption('Wwwc')
      const WwwcTool = cornerstoneTools.WwwcTool
      cornerstoneTools.addTool(WwwcTool)
      cornerstoneTools.setToolActive('Wwwc', {
        mouseButtonMask: 1,
      })
    },
    // 方位
    OrientationMarkers() {
      let OrientationMarkersTool = cornerstoneTools.OrientationMarkersTool
      cornerstoneTools.addTool(OrientationMarkersTool, {
        configuration: {
          drawAllMarkers: true,
        },
      })
      cornerstoneTools.setToolActive('OrientationMarkers', {
        mouseButtonMask: 1,
      })
    },
    // 上下翻页
    StackScroll() {
      this.removeOption('StackScroll')
      let StackScrollTool = cornerstoneTools.StackScrollTool
      cornerstoneTools.addTool(StackScrollTool, {
        configuration: {
          loop: true, //是否循环
          allowSkipping: true, //允许跳过， false 向上后就不能在滚动
        },
      })
      cornerstoneTools.setToolActive('StackScroll', {
        mouseButtonMask: 1,
      })
    },

    //清除上一次操作，并添加本次操作
    /**
     * @desc 清除上一次的操作
     */
    removeOption(currentName) {
      if (this.lastToolName && this.lastToolName !== currentName && this.lastToolName === 'RotateTouch' || currentName === 'RotateTouch') {
          //清除上一次
          cornerstoneTools.removeTool(this.lastToolName);
          this.lastToolName = currentName;
      } else {
        this.lastToolName = currentName
      }
    },
    //长度测量
    Length() {
      this.removeOption('Length')
      const LengthTool = cornerstoneTools.LengthTool

      cornerstoneTools.addTool(LengthTool)
      cornerstoneTools.setToolActive('Length', {
        mouseButtonMask: 1,
      })
    },
    //点测量
    Probe() {
      this.removeOption('Probe')
      const ProbeTool = cornerstoneTools.ProbeTool

      cornerstoneTools.addTool(ProbeTool)
      cornerstoneTools.setToolActive('Probe', {
        mouseButtonMask: 1,
      })
    },
    //矩形
    Rectangle() {
      this.removeOption('RectangleRoi')
      const RectangleRoiTool = cornerstoneTools.RectangleRoiTool

      cornerstoneTools.addTool(RectangleRoiTool)
      cornerstoneTools.setToolActive('RectangleRoi', {
        mouseButtonMask: 1,
      })
    },
    //角度测试
    Angle() {
      this.removeOption('Angle')
      const AngleTool = cornerstoneTools.AngleTool
      cornerstoneTools.addTool(AngleTool)
      cornerstoneTools.setToolActive('Angle', {
        mouseButtonMask: 1,
      })
    },
    // 单项标记清除工具
    Test() {
      const EraserTool = cornerstoneTools.EraserTool
      cornerstoneTools.addTool(EraserTool)
      cornerstoneTools.setToolActive('Eraser', {
        mouseButtonMask: 1,
      })
    },
    //图像增强
    Interpolation() {
      let canvas = this.$refs.img_canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.pixelReplication = !viewport.pixelReplication
      cornerstone.setViewport(canvas, viewport)
    },
    //反色
    Invert() {
      this.removeOption('Invert')
      let canvas = this.$refs.img_canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.invert = !viewport.invert
      cornerstone.setViewport(canvas, viewport)
    },
    //自由旋转
    Rotate() {
      // let el = document.querySelector('.viewport')
      this.removeOption('RotateTouch')
      const RotateTouchTool = cornerstoneTools.RotateTouchTool
      cornerstoneTools.addTool(RotateTouchTool)
      cornerstoneTools.setToolActive('RotateTouch', {
        mouseButtonMask: 1,
      })
      // let RotateTool = cornerstoneTools.RotateTool
      // //roundAngles 为true 并设置 horizontal或vertical 模式会变成反方向旋转
      // //并且对应的属性也要设置为true, 不然会有平分线区分方向
      // cornerstoneTools.addTool(RotateTool, {
      //   configuration: {
      //     roundAngles: true, //未true是会Math.ceil取整
      //     flipHorizontal: false, //水平反转
      //     flipVertical: false, //垂直反转
      //     rotateScale: 1, //控制旋转的快慢
      //   },
      // })
      // cornerstoneTools.setToolActive('Rotate', {
      //   mouseButtonMask: 1,
      // })
      // //改变模式
      // const ActiveScissorTool = cornerstoneTools.getToolForElement(el, 'Rotate')
      // ActiveScissorTool.setActiveStrategy('horizontal')
    },
    //水平旋转
    HorizontalRotation() {
      this.removeOption('HorizontalRotation')
      let canvas = this.$refs.img_canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.hflip = !viewport.hflip
      cornerstone.setViewport(canvas, viewport)
    },
    //垂直旋转
    VerticalRotation() {
      this.removeOption('VerticalRotation')
      let canvas = this.$refs.img_canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.vflip = !viewport.vflip
      cornerstone.setViewport(canvas, viewport)
    },
    // 此方法是箭头 标记回调，不可删除
    setAnnotate() {
      console.log('123')
    },
    //箭头 标记
    ArrowAnnotate() {
      this.removeOption('ArrowAnnotate')
      // const ArrowAnnotateTool = cornerstoneTools.ArrowAnnotateTool
      // cornerstoneTools.addTool(ArrowAnnotateTool)
      // cornerstoneTools.setToolActive('ArrowAnnotate', {
      //   mouseButtonMask: 1,
      // })
      var that = this
      let ArrowAnnotateTool = cornerstoneTools.ArrowAnnotateTool
      cornerstoneTools.addTool(ArrowAnnotateTool, {
        configuration: {
          getTextCallback: function (cb, eventData) {
            // cb 回调函数     eventData   事件 e.detail数据
            that.arrowAnnotate = true
            that.setAnnotate = cb //回调
          },
          changeTextCallback: function (data, eventData, cb) {
            /**
             * data   toolState.data
             * eventData  e.detail
             * cb  回调函数
             */
            console.log(123)
            cb(prompt('正在改变值'))
          },
          drawHandlesOnHover: false, //是否显示圆点
          hideHandlesIfMoving: false, //是否显示圆点轨迹
          arrowFirst: true, //箭头的方向显示
          renderDashed: false, //是否是虚线显示
          allowEmptyLabel: false, // 是否可以输入空值, 若为空则不渲染
          drawHandles: true, //不显示圆点也不显示圆点移动轨迹
        },
      })
      cornerstoneTools.setToolActive('ArrowAnnotate', {
        mouseButtonMask: 1,
      })
    },
    //骨窗
    Bone() {
      this.removeOption('Bone')
      let canvas = this.$refs.img_canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 2000
      viewport.voi.windowCenter = 300
      cornerstone.setViewport(canvas, viewport)
    },
    //软组织窗
    SoftTissue() {
      this.removeOption('SoftTissue')
      let canvas = this.$refs.img_canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 400
      viewport.voi.windowCenter = 20
      cornerstone.setViewport(canvas, viewport)
    },
    //脑窗
    Brain() {
      this.removeOption('Brain')
      let canvas = this.$refs.img_canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 80
      viewport.voi.windowCenter = 32
      cornerstone.setViewport(canvas, viewport)
    },
    //肺窗
    Lung() {
      this.removeOption('Lung')
      let canvas = this.$refs.img_canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 1600
      viewport.voi.windowCenter = -600
      cornerstone.setViewport(canvas, viewport)
    },
    // 清除所有测量标记工具记录
    init() {
      const ToolStateManager = cornerstoneTools.globalImageIdSpecificToolStateManager
      // let markings = cornerstoneTools.getToolState(this.$refs.img_canvas, 'FreehandRoi');
      ToolStateManager.restoreImageIdToolState(this.cleanupToolImgID, {
        FreehandRoi: { data: '' },
      })
      cornerstoneTools.addTool(cornerstoneTools.FreehandRoiTool)
      cornerstoneTools.setToolPassive('FreehandRoi')
    },
    BrushTool() {
      let BrushTool = cornerstoneTools.BrushTool
      cornerstoneTools.addTool(BrushTool, {
        configuration: {
          alwaysEraseOnClick: true, //点击擦除，true 会没有红点显示， false会出现红点， 但实际上没啥效果
        },
      })
      cornerstoneTools.setToolActive('Brush', {
        mouseButtonMask: 1,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.image_container {
  height: 100%;
  background-color: black;
}
::v-deep .van-radio__label {
  color: white;
}
::v-deep .van-field__control {
  border: 1px solid rgb(145, 145, 145);
  text-indent: 1rem;
}
.img_dicom {
  width: 100%;
  height: calc(100% - 46px);

  &_nav {
    width: 100%;
    height: 55px;
    color: white;
    font-size: 12px;
    text-align: center;
    display: flex;
    flex-wrap: nowrap;
    padding-left: 5px;
    justify-content: space-between;
    background-color: rgba(86, 85, 85, 0.5);

    .active {
      background-color: rgb(72, 98, 135);
    }

    .wrapper_left {
      width: calc(100% - 90px);
      overflow: hidden;
    }
    p {
      white-space: nowrap;
      overflow: hidden;
    }
    &_left {
      display: flex;
      width: 100%;

      li {
        width: 55px;
        height: 45px;
        margin: 5px 5px 5px 0;
        padding: 2px;
        border-radius: 4px;
        background-color: black;

        .img_dicom_nav_img {
          width: 24px;
          height: 23px;
        }
      }

      /* “active”添加样式 */
      li:active {
        opacity: 0.6;
      }
    }

    .img_dicom_nav_img {
      width: 20px;
      height: 20px;
      margin: auto;
    }

    &_right {
      width: 103px;
      display: flex;
      .img_dicom_nav_reset:nth-child(1) {
        .img_dicom_nav_img {
          width: 24px;
          height: 23px;
          line-height: 24px;
        }
      }
      .img_dicom_nav_reset:nth-child(2) {
        .img_dicom_nav_img {
          width: 18px;
          height: 23px;
          img {
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      & > div {
        width: 45px;
        height: 45px;
        padding: 2px;
        border-radius: 4px;
        margin: 5px 0 5px 5px;
        background-color: black;
      }

      & > div:nth-child(1) {
        margin: 5px 0 0px 0px;
      }
    }
  }

  .viewportWrapper {
    height: calc(100% - 60px);
    color: #d8d8d8;
    position: relative;

    .viewport {
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      position: relative;
    }

    & > div {
      position: absolute;
      left: 5px;
      right: 5px;
      font-size: 12px;
    }
    .overlay_top {
      top: 5px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .overlay_b {
      display: flex;
      justify-content: space-between;
      .overlay {
        display: flex;
        align-items: flex-end;
      }
    }

    .overlay_bottom {
      bottom: 5px;

      .drag_min {
        margin-top: 5px;
      }
    }

    .overlay {
      width: 50%;
      // position: absolute;
    }

    // }
  }

  .img_list {
    color: white;
    overflow-y: auto;
    height: calc(100% - 50px);

    li {
      margin: 10px;
      display: flex;
      border-radius: 5px;
      border: 3px solid transparent;
      background-color: #31374d;
      padding: 5px;

      .menu_text {
        padding-left: 10px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }

    .serialActive {
      border-color: rgb(90, 142, 219);
    }

    .menu_imge {
      pointer-events: none;
    }
  }

  .van-cell::after {
    border: none;
  }

  .van-cell {
    color: white;
    align-items: center;
    padding: 3px 16px;
    border-bottom: 1px solid black;
    background-color: rgb(45, 50, 69);

    .van-cell__title {
      font-size: 18px;
      color: rgb(113, 187, 230);
      font-weight: 600;
    }

    & > div:nth-child(2) {
      font-size: 12px;
      text-align: right;
      margin-right: 10px;
    }

    & > div:nth-child(3) {
      width: 20px;
      height: 20px;
    }
  }
}

.van_popup {
  width: 80%;
  height: 50%;
  background-color: #3b3b3b;
  color: white;
  padding: 10px;
  // position: relative;
  h3 {
    font-weight: bold;
    padding: 20px 0;
    margin: auto;
    text-align: center;
  }
  .set_location_b {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    button {
      height: 30px;
      background-color: transparent;
      color: white;
    }
  }
}
</style>